var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card',{scopedSlots:_vm._u([{key:"card-title",fn:function(){return [_c('span',{staticClass:"card-title mb-16"},[_vm._v("Mot de passe")])]},proxy:true},{key:"card-content",fn:function(){return [_c('edit-password-form')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }